import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { useRouter } from 'next/router'
import SiteHeader from '@/components/generals/site-header'
import SiteFooter from '@/components/generals/site-footer'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    const router = useRouter()
    const path = router.asPath.split(/[?#]/)[0]

    return (
        <div id='top' className='flex min-h-screen flex-col'>
            <a
                href='#main-content'
                className='sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[60] focus:rounded-sm focus:bg-foreground focus:px-4 focus:py-2.5 focus:text-sm focus:text-background'
            >
                Skip to content
            </a>

            <SiteHeader />

            <main
                id='main-content'
                key={path}
                tabIndex={-1}
                className='flex-1 animate-in fade-in duration-500 focus:outline-none'
            >
                {children}
            </main>

            <SiteFooter />
        </div>
    )
}
